import momentEU from 'moment/locale/en-ca'

const components = {
  momentName: 'en-ca',
  momentLocale: momentEU
}

const locale = {
  'message': '-',
  'layouts.application': 'Application',
  'layouts.current': 'current',
  'layouts.switch': 'switch',
  'layouts.onlineservice': 'Online Service',
  'layouts.usercenter': 'User Center',
  'layouts.helpcenter': 'Help Center',
  'layouts.logout': 'Logout',
  'layouts.allapplication': 'Applications',
  'layouts.history': 'history',
  'layouts.customscene': 'Custom Scene',
  'layouts.commonmenu': 'History',
  'layouts.search.placeholder': 'Please input keywords, search menu',
  'layouts.text.undefined': 'undefined',
  'form-modal.cancel': 'Cancel',
  'form-modal.submit': 'Save',
  'form-modal.selected': 'Selected',
  'form-modal.action': 'Action',
  'form-modal.custom.title': 'Custom Scene menus',
  'form-modal.system.title': 'Custom System menus',
  'form-modal.menuname.placeholder': 'Please enter a name',
  'form-modal.remark.placeholder': 'remarks',
  'please_download_and_view请下载后查看': 'The current log has more than 1000 words, for your viewing experience, please download and view'
}

export default {
  ...components,
  ...locale
}
